export default __webpack_public_path__ + "navigation-examples-building-extrusion-960-e67c4f996f3fc3e57ebceb453c6a07c2.webp";